export default __webpack_public_path__ + "static/media/P2-Tip.18f79385.svg";